// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title__2UkbA"};